import { useEffect, useRef } from 'react';

export default function Cursor() {
  const cursorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const isCoarse = window.matchMedia('(pointer: coarse)').matches;
    const isNarrow = window.innerWidth < 900;
    if (isCoarse || isNarrow) return;

    const el = cursorRef.current;
    if (!el) return;

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let currX = mouseX;
    let currY = mouseY;
    let raf = 0;

    const onMove = (e: MouseEvent) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const expand = target.closest(
        'a, button, [data-cursor="expand"], .bento__card, img, .tlink'
      );
      if (expand) {
        el.classList.add('is-expand');
      } else {
        el.classList.remove('is-expand');
      }
    };

    const tick = () => {
      currX += (mouseX - currX) * 0.18;
      currY += (mouseY - currY) * 0.18;
      el.style.transform = `translate(${currX}px, ${currY}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener('mousemove', onMove, { passive: true });
    raf = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={cursorRef} className="cursor" aria-hidden="true" />;
}